import { Typography } from '@euler/app/components/typography';
import { useOrderDrafts } from '@euler/app/flows/order/pages/OrderScreen/functions/useOrderDrafts';
import { Center } from '@euler/components/Center';
import { StatusColors } from '@euler/components/Colors';
import { Icon } from '@euler/components/Icomoon';
import { HStack } from '@euler/components/layout/Stack';
import { PredefinedHitSlops } from '@euler/functions/predefinedHitSlops';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { Text, TouchableOpacity } from 'react-native';

export const OrderPageHeaderRight = memo(() => {
  const { rpx } = useResponsiveContext();
  const { availableDrafts, currentDraft, showOrderDraftsModal } =
    useOrderDrafts();

  return (
    <HStack
      css={`
        padding-right: ${rpx(15)}px;
      `}
    >
      {currentDraft != null ? (
        <>
          <Icon name="check" size={rpx(14)} color={StatusColors.Success} />
          <Typography.Label size={rpx(10)} color={StatusColors.Success}>
            已暂存
          </Typography.Label>
        </>
      ) : null}
      {availableDrafts.length ? (
        <TouchableOpacity
          css={`
            margin-left: ${rpx(8)}px;
            padding-right: ${rpx(2)}px;
          `}
          hitSlop={PredefinedHitSlops.large}
          onPress={showOrderDraftsModal}
        >
          <Icon name="more-vertical" size={rpx(22)} />
          <Center
            css={`
              position: absolute;
              top: ${rpx(-4)}px;
              right: ${rpx(-4)}px;
              width: ${rpx(14)}px;
              height: ${rpx(14)}px;
              border-radius: ${rpx(50)}px;
              background-color: red;
            `}
          >
            <Text
              css={`
                font-size: ${rpx(8)}px;
                color: #fff;
                line-height: ${rpx(14)}px;
                text-align: center;
              `}
            >
              {availableDrafts.length}
            </Text>
          </Center>
        </TouchableOpacity>
      ) : null}
    </HStack>
  );
});
